<template>
  <layout-main-inner>
    <template slot="action">
      <el-button
        slot="action"
        type="primary"
        size="small"
        @click="create">新增内容</el-button>
    </template>
    <layout-card-wrap hasHeaderSlot>
      <div slot="form">
        <el-input
          v-model="config.title"
          clearable
          placeholder="请输入内容标题"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </div>
      <el-table
        border
        :data="list">
        <el-table-column
          label="内容标题"
          prop="title"
          min-width="140"></el-table-column>
        <el-table-column
          min-width="240"
          label="内容说明"
          prop="name"></el-table-column>
        <el-table-column
          label="浏览次数"
          width="80"
          prop="viewCount"></el-table-column>
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="{row}">
            <el-button
              type="text"
              @click="update(row)">编辑</el-button>
            <el-button
              type="text"
              @click="deleteRow(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>

    <edit-message-modal
      ref="edit"
      @fetch="fetchList" />
  </layout-main-inner>
</template>
<script>
import Portal from '@/service/portal'
import EditMessageModal from './busi/edit-message-modal.vue'
export default {
  name: 'WxappMessageIndex',
  components: { EditMessageModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, contentTypes: [0], title: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    update(row) {
      const { msgId, title, content, name } = row
      this.$refs.edit.init({ msgId, title, content: this.$splitImage(content), name })
    },
    create() {
      this.$refs.edit.init({ })
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Portal.getmessages({ ...this.config })
        .then(res => {
          const { result, message, records, total } = res.data
          this.loading = false
          if ([0, 13].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    deleteRow(row) {
      this.$confirm('您确定删除该条内容?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Portal.deletemessage({ msgId: row.msgId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    }
  }
}
</script>
